export const mixins = {
    methods: {
        //创建随机字符串
        createNonceStr() {
            let str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let strArr = str.split("");
            let nums = "";
            for (let i = 0; i < 16; i++) {//这里是几位就要在这里改变
                let id = parseInt(Math.random() * 61);
                nums += strArr[id];
            }
            return nums;
        },
        //获取图片验证码
        getImgVerifyCode() {
            this.token = this.createNonceStr();
            this.$post('user/getVerifyCode', {token: this.token}).then(result => {
                this.verifyCodeImg = result.data;
            })
        }
    }
}